import { MODAL__MUTATIONS } from "../mutation-types";
import { MODAL__ACTIONS } from "../action-types";

const state = {
  open: false,
};

const mutations = {
  [MODAL__MUTATIONS.SET_IS_OPEN](state) {
    state.open = !state.open;
  },
};

const actions = {
    [MODAL__ACTIONS.OPEN]({ commit }) {
      commit(MODAL__MUTATIONS.SET_IS_OPEN);
    },
  };

export default {
  namespaced: true,
  strict: process.env.NODE_ENV !== "production",
  state,
  actions,
  mutations,
};
